module.exports = __webpack_public_path__ + "img/event_note.cca63aa7.svg";